const o = Symbol("dialogInjectionKey");
export {
  o as dialogInjectionKey
};
